import useWindowWidth from './use-window-width'

export default function useIsMobile() {
  const windowWidth = useWindowWidth()
  return windowWidth <= 640
}
